var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendStatusReportViewComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#fcbb04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendStatusReportViewComponent);
export default __webpack_public_path__ + "static/media/send-status-report-view-component.a764e438a3f19b7724fc736404b47bab.svg";
export { ForwardRef as ReactComponent };